import { createContext, useContext } from "react";

import type { TestAttribute } from "./shared.ts";

type FormFieldContext = TestAttribute & {
  name: string;
  controlId: string;
  explicitLabel?: boolean;
  disabled?: boolean;
};

export const FormFieldContext = createContext<FormFieldContext | undefined>(undefined);
FormFieldContext.displayName = "FormFieldContext";

export const useFieldContext = () => {
  const context = useContext(FormFieldContext);
  if (!context) {
    throw new Error(`
    No Field context. FieldLabel etc designed to only be used inside FormField`);
  }
  return context;
};

export const useOptionalFieldContext = (): FormFieldContext | undefined => {
  return useContext(FormFieldContext);
};
